import React from 'react';

class WizardItemNumberedBoxes extends React.Component {

	constructor(props) {

		super(props);
		this.state = {
			value: undefined
		};

		this.onChange = this.onChange.bind(this);
	}

	componentDidMount() {
		if (!this.props.data.Buttons.HideButtonsBelowQuestion) {
			this.setState({ value: Number(this.props.data.Answer) })
		}
	}

	

	componentDidUpdate() {
		if ((this.state.value !== null) && ((this.props.previousQuestion > this.props.currentStep) && (this.props.data.Buttons.HideButtonsBelowQuestion && (this.props.goToRev && (this.props.currentStep === this.props.data.CurrentItem - 1))))) {
			this.setState({ value: null })
		}
		this.props.setRev(false);
	}

    onChange(e) {
        let val = Number(e.target.value)
        this.setState({ value: val });
        this.props.submitAnswer(val);
    }

	render() {
		let numBoxes = [];
		for (let i = this.props.data.RangeMinValue; i <= this.props.data.RangeMaxValue; i++) {
			numBoxes.push(i);
		}

		console.log('render this.state.value', this.state.value)

		return (
			<div className="wizard-item wizard-item__numbered-boxes">

				<input type="hidden" data-trackingid={this.props.data.QuestionTrackingId} value={this.state.value} />

				{numBoxes.map((val, idx) => {
					return (
						<div className="wizard-item__numbered-box" key={idx} >
							<input
								type="radio"
								id={`nb-${idx}-${this.props.data.Id}`}
								value={val}
								checked={(val === this.state.value)}
								name={this.props.data.Id}
								onClick={this.onChange} />
							<label htmlFor={`nb-${idx}-${this.props.data.Id}`}
								className={(val <= this.state.value) ? "isActive" : ""}
							>
								<span className="text">{val + ((val === this.props.data.RangeMaxValue && this.props.data.HasRangeMaxValuePlusSign) ? "+" : "")}</span>
							</label>
						</div>
					)
				})}
			</div>
		)
	}
}

export default WizardItemNumberedBoxes;